export const CMS_BLOCK = {
  MAIN_MENU: 'main_menu',
  MEGA_MENU_SHOP: 'main_menu_shop_products',
  MEGA_MENU_COMMUNITY: 'main_menu_community',
  MEGA_MENU_BRAND: 'main_menu_shop_brand',
  MAIN_MENU_MOBILE: 'mobile_main_menu',
  MEGA_MENU_MOBILE_SHOP: 'mobile_main_menu_shop_products',
  MEGA_MENU_MOBILE_BRAND: 'mobile_main_menu_shop_brand',
  MEGA_MENU_MOBILE_COMMUNITY: 'mobile_main_menu_community',
  FOOTER_CONTACT: 'footer_contact',
  FOOTER_FAQS: 'footer_faqs',
  FOOTER_QUICK_LINKS: 'footer_quick_links',
  FOOTER_NEWSLETTER: 'footer_newsletter_sign_up',
  FOOTER_LEGAL: 'footer_legal',
  HOME_SLIDER: 'home_banner',
  HOME_REVIEWS: 'home_reviews',
  HOME_FIND_SOLUTION: 'home_find_solution',
  HOME_BRANDS: 'home_brands',
  HOME_CATEGORIES: 'home_featured_categories',
  HOME_POSTS: 'home_featured_posts',
  HOME_COMMUNITY: 'home_community',
  HOME_FEATURED_PRODUCTS: 'home_featured_products',
  SIZE_CHART_BOTTOM: 'size_chart_bottom',
  OUR_STORY: 'our-story-page',
  COMMUNITY: 'community-page',
  FAQ: 'faq-page',
  PRIVACY_POLICY: 'privacy-policy-page',
  COMPARISON_TOP_BANNER: 'comparison_top_banner',
  FACEBOOK_COMMUNITY: 'facebook-community',
  SUCCESS_FEATURED_POSTS: 'success-featured-posts',
  PS_VARIETY_PACK: 'ps_variety_pack',
  PLP_FREE_SHIPPING: 'plp_free_shipping',
  PS_NO_RESULTS: 'product_selector_no_results',
  PROMO_BANNER: 'promo_banner',
  PPL_HERO: 'ppl_hero',
  PPL_FEATURED: 'ppl_featured',
  PPL_BENEFITS: 'ppl_benefits',
  PPL_REVIEWS: 'ppl_reviews',
  BLOG_SIDEBAR_GENERAL: 'blog_sidebar',
  BLOG_SIDEBAR_WELCOME: 'blog_sidebar_welcome',
  BLOG_SIDEBAR_SUBSCRIBE: 'blog_sidebar_subscribe',
  BLOG_SIDEBAR_PERFECT_PRODUCT: 'blog_sidebar_perfect_product',
  ORDER_SUCCESS_CONTENT_SG: 'order_success_content_sg',
  PPQ_INTRO: 'ppq_intro',
  PPQ_SUCCESS_MODAL: 'ppq_success_modal',
  PPQ_PRODUCT_RESULT: 'ppq_product_result',
  PPQ_PRODUCT_RESULT_BOTTOM: 'ppq_product_result_bottom',
  PPQ_ADD_TO_MODAL: 'ppq_add_to_modal'
}

export const MENU_ITEMS = [
  {
    label: 'Shop Products',
    url: 'shop',
    block: CMS_BLOCK.MEGA_MENU_SHOP,
    mobileBlock: CMS_BLOCK.MEGA_MENU_MOBILE_SHOP
  },
  {
    label: 'Shop by Brand',
    url: 'shop-by-brand',
    block: CMS_BLOCK.MEGA_MENU_BRAND,
    mobileBlock: CMS_BLOCK.MEGA_MENU_BRAND
  },
  {
    label: 'Community',
    url: 'community',
    block: CMS_BLOCK.MEGA_MENU_COMMUNITY,
    mobileBlock: CMS_BLOCK.MEGA_MENU_COMMUNITY
  }
]

export const BREAKPOINT = {
  LG: '1366px',
  MD: '1024px'
}

export const PRODUCT_SPECS = [
  'hip_waist_min',
  'hip_waist_max',
  'pad_length',
  'individually_wrapped',
  'overnight',
  'discreet',
  'patterned_design',
  'wings',
  'inner_leg_cuffs',
  'reusable'
]

export const CUSTOMER_SIDEBAR_LINKS = [
  {
    url: '/customer/account/dashboard',
    label: 'Dashboard'
  },
  {
    url: '/customer/account/subscriptions',
    label: 'Manage Subscription'
  },
  {
    url: '/customer/account/orders',
    label: 'Orders'
  },
  {
    url: '/customer/account/wishlist',
    label: 'Favorites'
  },
  {
    url: '/customer/account/payment',
    label: 'Payment Methods'
  },
  {
    url: '/customer/account/addresses',
    label: 'Addresses'
  },
  {
    url: '/customer/account/about',
    label: 'About Me'
  }
]

export const PRODUCT_SELECTOR_CODE = 'sofiaandgraceproductquiz'

export const ALL_POSTS_CATEGORY = 'all-posts'
